import { render, staticRenderFns } from "./TuSectionTabs.vue?vue&type=template&id=0ed885fb&scoped=true&"
import script from "./TuSectionTabs.vue?vue&type=script&lang=js&"
export * from "./TuSectionTabs.vue?vue&type=script&lang=js&"
import style0 from "./TuSectionTabs.vue?vue&type=style&index=0&id=0ed885fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed885fb",
  null
  
)

export default component.exports